module.exports = __webpack_public_path__ + "static/img/banner-m.473817b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-m.png
// module id = EmEZ
// module chunks = 0